import { CLY_E_PV } from './const'
import { getAllUrlParameters } from './utils'

const currentCountlyPageviewSrc = document.currentScript?.src
const currentCountlyPageviewparams = getAllUrlParameters(currentCountlyPageviewSrc)
window.currentCountlyPageHistory = []

function trackRoute(route: string, search: string = '') {
  if (!currentCountlyPageviewSrc) {
    console.error('无法获取currentScript')
    return
  }

  window.currentCountlyPageSrc = route
  const preRoute = window.currentCountlyPageHistory[window.currentCountlyPageHistory.length - 1]

  const { appKey, name, pageviewWaitUserDetails, debug, ...restParams } = currentCountlyPageviewparams

  if (window[name || 'Countly']) {
    // 循环检查window.Countly.isUserDetailInit是否为true
    const toTrack = () => {
      debug && console.log('pv上报[route, preRoute, search, isTrackInited]', route, preRoute, search, window.Countly.isTrackInited)
      window[name || 'Countly'].add_business_event({
        key: CLY_E_PV,
        segmentation: {
          href: route,
          fromHref: preRoute || '',
          search: search, // ✅ 新增：search 字段
          ...restParams,
        },
      })
    }
    const waitUserDetailsTrack = () => {
      debug && console.log('用户信息是否初始化 isTrackInited', window.Countly.isTrackInited)
      if (!window.Countly.isTrackInited) {
        return setTimeout(waitUserDetailsTrack, 100)
      }
      toTrack()
    }
    if (pageviewWaitUserDetails) {
      waitUserDetailsTrack()
    } else {
      toTrack()
    }
  }
  window.currentCountlyPageHistory.push(route)
}

// ✅ 修改：包含 search 参数
function getRoute() {
  return window.location.pathname + window.location.search + window.location.hash
}

// ✅ 新增：获取 search 参数
function getSearch() {
  return window.location.search
}

interface RouteTracker {
  lastRoute: string
  lastSearch: string // ✅ 新增：记录上次的 search
  debounceTimer: number | null
  isProcessing: boolean
}

const routeTracker: RouteTracker = {
  lastRoute: '',
  lastSearch: '', // ✅ 新增
  debounceTimer: null,
  isProcessing: false
}

// ✅ 修改：添加 search 参数判断
function optimizedTrackRoute(newRoute: string, newSearch: string, source: string) {
  // 清除之前的防抖定时器
  if (routeTracker.debounceTimer) {
    clearTimeout(routeTracker.debounceTimer)
    routeTracker.debounceTimer = null
  }
  
  // ✅ 修改：路由或 search 参数变化时才上报
  if (routeTracker.lastRoute === newRoute && routeTracker.lastSearch === newSearch) {
    return
  }
  
  // 正在处理时跳过
  if (routeTracker.isProcessing) {
    return
  }
  
  routeTracker.debounceTimer = setTimeout(() => {
    routeTracker.isProcessing = true
    
    try {
      routeTracker.lastRoute = newRoute
      routeTracker.lastSearch = newSearch // ✅ 新增：更新 lastSearch
      trackRoute(newRoute, newSearch) // ✅ 修改：传入 search 参数
    } catch (error) {
      console.error('Route tracking error:', error)
    } finally {
      routeTracker.isProcessing = false
      routeTracker.debounceTimer = null
    }
  }, 16) // 约一帧的时间，减少延迟
}

export function initPv() {
  if (window.routeTrackerInitialized) return
  window.routeTrackerInitialized = true

  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState

  // 重写 history 方法
  history.pushState = function (...args) {
    originalPushState.apply(this, args)
    optimizedTrackRoute(getRoute(), getSearch(), 'pushState') // ✅ 修改：传入 search
  }

  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args)
    optimizedTrackRoute(getRoute(), getSearch(), 'replaceState') // ✅ 修改：传入 search
  }

  // 事件监听器
  window.addEventListener('popstate', () => {
    optimizedTrackRoute(getRoute(), getSearch(), 'popstate') // ✅ 修改：传入 search
  })

  window.addEventListener('hashchange', () => {
    optimizedTrackRoute(getRoute(), getSearch(), 'hashchange') // ✅ 修改：传入 search
  })

  // 初始化路由跟踪
  const initialRoute = getRoute()
  const initialSearch = getSearch() // ✅ 新增：获取初始 search
  routeTracker.lastRoute = initialRoute
  routeTracker.lastSearch = initialSearch // ✅ 新增：初始化 lastSearch
  trackRoute(initialRoute, initialSearch) // ✅ 修改：传入 search
}

initPv()